<template>
  <Popover ref="popover" :showHeader="true" :headerTitle="title" :sizeClass="popoverSizeClass" placement="bottom" :scrollable="scrollable" :scrollHeight="scrollHeight">
    <div class="editor-option-content">
      <div :class="['row', 'no-gutters', { 'active': option.value == value && showSelection}]" v-for="option of optionList" :key="option.value" @click.prevent="updateOption(option.value)">
        <div class="col-2 option-icon">
          <i :class="[option.icon]" />
        </div>
        <div :class="[infoColumnClass, 'option-name']">
          <strong>{{option.name}}</strong><br />
          <span v-html="option.description" />
        </div>
        <div class="col-2 option-value" v-if="showSelection">
          <i class="far fa-check-circle fa-fw status-active" v-if="option.value == value" />
          <i class="far fa-circle fa-fw text-muted" v-if="option.value != value" />
        </div>
      </div>
      <div v-if="!optionList || optionList.length == 0" class="text-center text-muted font-italic py-4">
        {{emptyMessage}}
      </div>
    </div>
  </Popover>
</template>

<style scoped lang="scss">
$selection-row-height: 58px;
.editor-option-content .row {
  min-height: $selection-row-height;
  cursor: pointer;
}
.editor-option-content .row:not(:last-child){
  border-bottom: 1px solid #dee2e6;
}
.editor-option-content .row:hover{
  background-color: #f5f5f5;
}
.theme-dark .editor-option-content .row:hover{
  color: #474747;
}
.option-icon {
  font-size: 1.4rem;
  line-height: $selection-row-height;
  vertical-align: middle;
  text-align: center;
}
.editor-option-content .active .option-icon {
  color: $status-good;
}
.editor-option-content .option-name {
  padding-left: 6px;
  font-size: 11px;
}
.editor-option-content .option-name strong {
  font-size: 13px;
}
.editor-option-content .option-value {
  text-align: right;
  line-height: $selection-row-height;
  vertical-align: middle;
  font-size: 1.5rem;
  padding-right: 8px;
}
</style>


<script>
import Popover from '@/components/popover.vue'

export default {
  name: 'EditorSelectionPopover',
  model: {
    event: 'update'
  },
  components: {
    Popover
  },
  props: {
    title: {
      type: String,
      default: 'Options'
    },
    popoverSizeClass: {
      type: String,
      default: 'popover-medium'
    },
    scrollable: Boolean,
    scrollHeight: {
      type: [String, Number],
      default: '40vh'
    },
    showSelection: Boolean,
    optionList: Array,
    emptyMessage: String,
    value: String
  },
  computed: {
    infoColumnClass() {
      if(this.showSelection)
        return 'col-8'
      return 'col-10'
    }
  },
  methods: {
    displayFromElement(element) {
      this.$refs.popover.displayFromElement(element)
    },
    updateOption(optionKey) {
      this.$emit('clickedOption', optionKey)
      this.$refs.popover.hidePopover()
      this.$emit('update', optionKey)
    }
  }
}
</script>
